import { Component, Input, Output, EventEmitter, TemplateRef } from '@angular/core';
import { IconName } from '@fortawesome/free-regular-svg-icons';

@Component({
  selector: 'app-item-selector',
  template: `

  <div class="w-full space-y-2 rounded-lg p-4 border border-[#7A7A7A]">

    <div class="flex justify-between items-center gap-1">
      <h3 class="font-bold text-sm w-full">{{ label }}</h3>
      <ng-content></ng-content>
    </div>

    <div class="w-full relative">
      <sigecom-input-search-new [placeholder]="placeholder" (searchChange)="onSearch($event)" />
    </div>
    <ng-content select="[below-search-bar]"></ng-content>

    <div class="flex flex-col w-auto gap-2 overflow-auto max-h-[16.5rem]">
      <sigecom-list-container>
        <sigecom-list-item outline *ngFor="let item of items">
          <div class="flex items-center gap-2">
            <div *ngIf="iconItemDisableFn(item)" class="{{classIconItem}}">
              <sigecom-menu-bar-item
                [icon]="iconItemName"
                [color]="iconItemColor"
              />
            </div>
            <div class="flex flex-col flex-1">
              <p class="text-[#012169] font-bold">{{ item.label || item.nome || item.estTxNome }}</p>
              <p class="text-[#787878] text-sm" *ngIf="showInscriptionLine && item.estTxNome">
                Participante: {{ item.insTxResumo }}
              </p>
              <p class="text-[#787878] text-sm" *ngIf="showInscriptionLine">
                Inscrição: {{ item.id?.toString() || item.insNrId?.toString() || '' }}
              </p>
              <!-- <sigecom-list-info info="" [value]="" /> -->
            </div>
              <div [ngClass]="statusItemClassFn(item)">
              <p class="w-full  whitespace-nowrap">{{ statusItemFn(item) }}</p>
              </div>
            <sigecom-menu-bar>
              <sigecom-menu-bar-item
                icon="plus"
                color="sigecom-info"
                *ngIf="!disabled"
                title="Adicionar"
                (clickAction)="onAdd(item)"
              />
            </sigecom-menu-bar>
          </div>
        </sigecom-list-item>
      </sigecom-list-container>
    </div>
</div>

  `,
})
export class ItemSelectorComponent {
  @Input() items: any[] = [];
  @Input() disabled: boolean = false;
  @Input() label: string = '';
  @Input() placeholder: string = 'Buscar';
  @Input() showInscriptionLine: boolean = true;
  @Input() statusItemFn: (item: any) => string = () => '';
  @Input() statusItemClassFn: (item: any) => string = () => '';
  @Input() iconItemDisableFn: (item: any) => boolean = () => false;
  @Input() iconItemName?: IconName;
  @Input() iconItemColor: string = '';
  @Input() classIconItem: string = '';
  @Output() search = new EventEmitter<string>();
  @Output() add = new EventEmitter<any>();

  onSearch(value: string) {
    this.search.emit(value);
  }

  onAdd(item: any) {
    if (!this.disabled) this.add.emit(item);
  }
}
